import {
  GameType,
  PromotionCampaignPrizeAmountMode,
  RedemptionLimitFrequencyPeriod,
} from '@Generated/back-office-client/src'
import { formatEnumLabel, getRealEnumValues } from '@Components/util/utils'

const createOptions = <T extends string>(
  values: readonly T[],
): Array<{ value: T; label: string }> => {
  return values.map((value) => ({
    value,
    label: formatEnumLabel(value),
  }))
}

const LIMIT_PERIOD_VALUES = getRealEnumValues(RedemptionLimitFrequencyPeriod)
const AMOUNT_MODE_VALUES = getRealEnumValues(PromotionCampaignPrizeAmountMode)
const GAME_TYPE_VALUES = getRealEnumValues(GameType)

export const LIMIT_PERIOD_OPTIONS = createOptions(LIMIT_PERIOD_VALUES)
export const GAME_TYPE_OPTIONS = [
  { value: 'ANY', label: 'Any' },
  ...createOptions(GAME_TYPE_VALUES),
]
export const AMOUNT_MODE_OPTIONS = createOptions(AMOUNT_MODE_VALUES)
